import type { EndCoordsGizmoSlice, EndCoordsGizmoState, ViewerSliceCreator } from "./types";

export const endCoordsGizmoInitialState: EndCoordsGizmoState = {
  endCoordsGizmoVisible: false,
  endCoordsGizmoPosition: [0, 0, 0],
  endCoordsGizmoQuaternion: [0, 0, 0, 1],
  endCoordsLocalPosition: [0, 0, 0],
  endCoordsLocalRotation: [0, 0, 0],
  endCoordsSnapEnabled: true,
  endCoordsPositionSnap: 0.01,
  endCoordsRotationSnap: Math.PI / 8,
};

export const createEndCoordsGizmoSlice: ViewerSliceCreator<EndCoordsGizmoSlice> = (set) => ({
  ...endCoordsGizmoInitialState,

  setEndCoordsGizmo: (msg) =>
    set((state) => {
      state.endCoordsGizmoVisible = msg.show;
      state.endCoordsGizmoPosition = msg.position;
      state.endCoordsGizmoQuaternion = msg.quaternion;
    }),

  setEndCoordsLocal: (msg) =>
    set((state) => {
      state.endCoordsLocalPosition = msg.position;
      state.endCoordsLocalRotation = msg.rotation;
      if (state.editLinksMode && state.editLinksEndEffectorMode === "custom" && state.editLinksEndEffectorLink) {
        state.editLinksEndEffectorOffsetXyz = msg.position;
        state.editLinksEndEffectorOffsetRpy = msg.rotation;
      }
    }),

  setEndCoordsSnapEnabled: (enabled) =>
    set((state) => {
      state.endCoordsSnapEnabled = enabled;
    }),

  setEndCoordsPositionSnap: (step) =>
    set((state) => {
      state.endCoordsPositionSnap = step;
    }),

  setEndCoordsRotationSnap: (step) =>
    set((state) => {
      state.endCoordsRotationSnap = step;
    }),
});
